<template>
  <div class="main-container">
    <div class="top-bar w-100 bg-white">
      <img
        src="@/assets/images/common/drip-logo.svg"
        width="100"
        height="34"
        alt="company"
      />
    </div>
    <div class="sub-bar"></div>
    <div class="w-100">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  mounted() {}
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables';

.main-container {
  @media screen {
    height: 100vh;
    overflow: auto;
  }
  .top-bar {
    height: 80px;
    padding: 24px;
    padding-left: 108px;
  }
  .sub-bar {
    width: 100%;
    height: 32px;
    background: linear-gradient(
      90deg,
      $wealthy-green-400 -33.82%,
      $noble-blue-500 100%
    );
  }
}
</style>
